import intercom from "@irati/utils/intercom"

export function logErrorToIntercom(metadata: Pick<PBError, "errorCode" | "errorData" | "traceId"> & {operationName?: string}) {
  return intercom.logError(metadata)
}
